import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import UsersConsultationLogDatatableHandler from '../containers/mixtesHandlers/UsersConsultationLogDatatableHandler/UsersConsultationLogDatatableHandler';

export default function ConsultationLogFire() {
  return (
    <>
      <CC.Box>
        <CC.Box mt="4">
          <UsersConsultationLogDatatableHandler />
        </CC.Box>
      </CC.Box>
    </>
  );
}
